

const contractMgmtReducer = (state = {}, action) => {
    switch (action.type) {
        case "GetContractCountSuccess":
            return Object.assign({}, state, {
                ContractCount: action.data,
            });
            break;
        case "GetContractTypeSuccess":
            return Object.assign({}, state, {
                ContractType: action.data,
            });
            break;
        case "GetPlanTypeSuccess":
            return Object.assign({}, state, {
                PlanType: action.data,
            });
            break;
        case "GetBillingTypeSuccess":
            return Object.assign({}, state, {
                BillingType: action.data,
            });
            break;
        case "GetContractStatusSuccess":
            return Object.assign({}, state, {
                contractStatus: action.data,
            });
            break;
        case "GetShipIdNameSuccess":
            return Object.assign({}, state, {
                shipListData: action.data,
            });
            break;
        case "GetContractCountFailure":
            return Object.assign({}, state, {
                arraylist: action.data,
            });
            break;
        case "GetContractDetailSuccess":
            return Object.assign({}, state, {
                ContractDetail: action.data,
            });
            break;
        case "GetContractDetailFailure":
            return Object.assign({}, state, {
                arraylist: action.data,
            });
            break;
        case "GetContractSearchSuccess":
            return Object.assign({}, state, {
                ContractSearchResult: action.data,
            });
            break;
        case "GetContractSearchFailure":
            return Object.assign({}, state, {
                ContractSearchResult: action.data,
            });
            break;
        case "PutContractDetailSuccess":
            return Object.assign({}, state, {
                PutContractDetail: action.data,
            });
            break;
        case "PutContractDetailFailure":
            return Object.assign({}, state, {
                PutContractDetail: action.data,
            });
            break;
        case "GetContractHistorySuccess":
            return Object.assign({}, state, {
                ContractHistory: action.data,
            });
            break;
        case "GetContractHistoryFailure":
            return Object.assign({}, state, {
                ContractHistory: action.data,
            });
            break;
        case "GetContractShipListSuccess":
            return Object.assign({}, state, {
                ContractShipList: action.data,
            });
            break;
        case "GetContractShipListFailure":
            return Object.assign({}, state, {
                ContractShipList: action.data,
            });
            break;
        case "GetContractClientNameSuccess":
            return Object.assign({}, state, {
                ContractClientName: action.data,
            });
            break;
        case "GetContractClientNameFailure":
            return Object.assign({}, state, {
                ContractClientName: action.data,
            });
            break;
        case "PostContractDetailSuccess":
            return Object.assign({}, state, {
                PostContractDetail: action.data,
            });
            break;
        case "PostContractDetailFailure":
            return Object.assign({}, state, {
                PostContractDetail: action.data,
            });
            break;
        case "getClientIMONOSuccess":
            return Object.assign({}, state, {
                ClientIMONO: action.data,
            });
            break;
        case "postContractAttachmentUploadSuccess":
            return Object.assign({}, state, {
                contractAttachment: action.data,
            });
            break;
        case "contractSearch":
            return Object.assign({}, state, {
                contractSearch: action.data,
            });
            break;
        default: {
            return state;
        }
    }
};
export default contractMgmtReducer;
